import React, { useState } from "react";
import "./Footer.scss";
import { footimg } from "../assets/icons";
import { Link, useNavigate } from "react-router-dom";
import { handleNavigate, verifyEmail } from "../utilities/handleNavigate";
import { toast } from "sonner";

const Footer = () => {
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
  });

  // on change handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // validation
  const handleValidation = () => {
    let status = true;
    let error = {};
    if (!formData.email) {
      error["email"] = "Email is required";
      status = false;
    } else if (!verifyEmail(formData.email)) {
      toast.error("Please enter valid email");
      status = false;
    }
    setError(error);
    return status;
  };

  // form submission
  const formSubmitHandler = async (e) => {
    try {
      e.preventDefault();
      if (handleValidation()) {
        setLoading(true);

        const fetchResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/api/latest-email`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const finalResponse = await fetchResponse.json();

        if (finalResponse?.status === 200) {
          toast.success(finalResponse.message);
          setFormData({
            email: "",
          });
        } else {
          toast.error(finalResponse.message);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="wrap_foot">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <div className="common_foot">
                <div className="wrap_logo">
                  <img src={footimg} alt="" />
                </div>
                <p className="txt">
                  Godide is a leading provider of online ride-sharing and
                  ride-hailing services. We are seamlessly connecting customers
                  to reliable, affordable, and convenient transportation.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-8">
              <div className="common_foot">
                <p className="head_txt">Contact</p>
                <ul>
                  <li>
                    <Link to="tel:+27 750651394">+27 750651394</Link>
                  </li>
                  <li>
                    <Link to="mailto:GodideCares@TheGodide.com">
                      GodideCares@TheGodide.com
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      Office No.1, Asgisa Building 127 Alice Street 478
                      Gillitts,Durban KwaZulu-Natal, South Africa 3603
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6 col-4">
              <div className="common_foot">
                <p className="head_txt">Usefull links</p>
                <ul>
                  <li>
                    <Link
                      to=""
                      onClick={() => {
                        handleNavigate("/", "#home", navigate);
                      }}
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to=""
                      onClick={() => {
                        handleNavigate("/", "#about", navigate);
                      }}
                    >
                      About us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to=""
                      onClick={() => {
                        handleNavigate("/", "#testimonial", navigate);
                      }}
                    >
                      Testimonials
                    </Link>
                  </li>
                  <li>
                    <Link
                      to=""
                      onClick={() => {
                        handleNavigate("/", "#faq", navigate);
                      }}
                    >
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link to="">Contact us</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="common_foot">
                <p className="head_txt">Usefull links</p>
                <p className="txt">
                  Be the first to recieve all latest post in your inbox
                </p>
                <form id="contact-us-form" onSubmit={formSubmitHandler}>
                  <div className="wrap_input_btn">
                    <input
                      className="input form-control"
                      placeholder="Email address"
                      type="email"
                      required
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={onChangeHandler}
                    />
                    <button className="button" type="submit" disabled={loading}>
                      {loading ? "Loading..." : "Send"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrap_terms">
        <div className="container">
          <div className="wrap_policy">
            <span>© Copyright 2025</span>
            <p>
              <Link to={"/terms-conditions"}>Terms of Service</Link>
              <Link to={"/privacy-policy"}>Privacy Policy</Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
